import * as React from "react";
import { useEffect, useRef, useState } from "react";
import ScrollBar from "react-perfect-scrollbar";
import { ScrollOptions } from "../../constants/ScrollOptions";
import { IdStyles } from "../../less/IdStyles";
import { MessageReceived } from "./MessageReceived";
import { MessageSent } from "./MessageSent";
export var ChatMessageView = React.memo(function (_a) {
    var chatInfo = _a.chatInfo, setScrollToBottom = _a.setScrollToBottom;
    var _b = useState(
    // tslint:disable-next-line:no-null-keyword
    null), messagesContainerRef = _b[0], setMessagesContainerRef = _b[1];
    // tslint:disable-next-line:no-null-keyword
    var messagesEndRef = useRef(null);
    var scrollToBottom = function () {
        if (messagesEndRef && messagesEndRef.current && messagesContainerRef) {
            messagesContainerRef.scrollTop =
                messagesEndRef.current.offsetTop - messagesContainerRef.offsetTop;
        }
    };
    var setContainerRef = function (ref) {
        if (ref) {
            setMessagesContainerRef(ref);
        }
    };
    // Exposing the scrollToBottom method to parent component
    setScrollToBottom(scrollToBottom);
    // Scrolling to bottom every time there's a new message or chat initialized
    useEffect(scrollToBottom, [chatInfo.length, messagesContainerRef]);
    return (React.createElement("div", { className: IdStyles.CoopChatMessageViewContainer },
        React.createElement(ScrollBar, { component: "div", options: ScrollOptions, containerRef: setContainerRef },
            chatInfo.map(function (message, index) {
                var messageElementType = message.isMessageOwn ? (React.createElement(MessageSent, { messageInfo: message })) : (React.createElement(MessageReceived, { messageInfo: message }));
                return (React.createElement("div", { key: message.proto.creationTimestamp + index }, messageElementType));
            }),
            React.createElement("div", { ref: messagesEndRef }))));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/chat/ChatMessageView.tsx
// module id = 2578
// module chunks = 3